/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { allCompaniesNumbersList } from '../fn/company-solution-admin-api/all-companies-numbers-list';
import { AllCompaniesNumbersList$Params } from '../fn/company-solution-admin-api/all-companies-numbers-list';
import { ApiResponseAnalytics } from '../models/api-response-analytics';
import { ApiResponseCompany } from '../models/api-response-company';
import { ApiResponseCompanyEmailReportUpdateRequest } from '../models/api-response-company-email-report-update-request';
import { ApiResponseListCompany } from '../models/api-response-list-company';
import { ApiResponseListPhoneCompany } from '../models/api-response-list-phone-company';
import { ApiResponseListWhatsAppConfig } from '../models/api-response-list-whats-app-config';
import { ApiResponsePagedResultCompany } from '../models/api-response-paged-result-company';
import { ApiResponsePagedResultPhoneCompany } from '../models/api-response-paged-result-phone-company';
import { ApiResponseSignupSurvey } from '../models/api-response-signup-survey';
import { ApiResponseTrialStatus } from '../models/api-response-trial-status';
import { convertToPermanentClient } from '../fn/company-solution-admin-api/convert-to-permanent-client';
import { ConvertToPermanentClient$Params } from '../fn/company-solution-admin-api/convert-to-permanent-client';
import { createCompany } from '../fn/company-solution-admin-api/create-company';
import { CreateCompany$Params } from '../fn/company-solution-admin-api/create-company';
import { deleteCompnayByRef } from '../fn/company-solution-admin-api/delete-compnay-by-ref';
import { DeleteCompnayByRef$Params } from '../fn/company-solution-admin-api/delete-compnay-by-ref';
import { deletePhoneCompanyByRef } from '../fn/company-solution-admin-api/delete-phone-company-by-ref';
import { DeletePhoneCompanyByRef$Params } from '../fn/company-solution-admin-api/delete-phone-company-by-ref';
import { downloadReportPdf } from '../fn/company-solution-admin-api/download-report-pdf';
import { DownloadReportPdf$Params } from '../fn/company-solution-admin-api/download-report-pdf';
import { downloadReportPricePdf } from '../fn/company-solution-admin-api/download-report-price-pdf';
import { DownloadReportPricePdf$Params } from '../fn/company-solution-admin-api/download-report-price-pdf';
import { getCompanyByRef } from '../fn/company-solution-admin-api/get-company-by-ref';
import { GetCompanyByRef$Params } from '../fn/company-solution-admin-api/get-company-by-ref';
import { getCompanyEmails } from '../fn/company-solution-admin-api/get-company-emails';
import { GetCompanyEmails$Params } from '../fn/company-solution-admin-api/get-company-emails';
import { getCompanyLogo1 } from '../fn/company-solution-admin-api/get-company-logo-1';
import { GetCompanyLogo1$Params } from '../fn/company-solution-admin-api/get-company-logo-1';
import { getCompanyWhatsAppConfig } from '../fn/company-solution-admin-api/get-company-whats-app-config';
import { GetCompanyWhatsAppConfig$Params } from '../fn/company-solution-admin-api/get-company-whats-app-config';
import { getConsumptionReports } from '../fn/company-solution-admin-api/get-consumption-reports';
import { GetConsumptionReports$Params } from '../fn/company-solution-admin-api/get-consumption-reports';
import { getGlobalConsumptionPrices } from '../fn/company-solution-admin-api/get-global-consumption-prices';
import { GetGlobalConsumptionPrices$Params } from '../fn/company-solution-admin-api/get-global-consumption-prices';
import { getListCompany } from '../fn/company-solution-admin-api/get-list-company';
import { GetListCompany$Params } from '../fn/company-solution-admin-api/get-list-company';
import { getSignupSurvey } from '../fn/company-solution-admin-api/get-signup-survey';
import { GetSignupSurvey$Params } from '../fn/company-solution-admin-api/get-signup-survey';
import { getWalletConsumptionSettings } from '../fn/company-solution-admin-api/get-wallet-consumption-settings';
import { GetWalletConsumptionSettings$Params } from '../fn/company-solution-admin-api/get-wallet-consumption-settings';
import { PageConsumptionReportDto } from '../models/page-consumption-report-dto';
import { patchApproveStatus } from '../fn/company-solution-admin-api/patch-approve-status';
import { PatchApproveStatus$Params } from '../fn/company-solution-admin-api/patch-approve-status';
import { patchArchiveStatus4 } from '../fn/company-solution-admin-api/patch-archive-status-4';
import { PatchArchiveStatus4$Params } from '../fn/company-solution-admin-api/patch-archive-status-4';
import { patchPhoneArchiveStatus } from '../fn/company-solution-admin-api/patch-phone-archive-status';
import { PatchPhoneArchiveStatus$Params } from '../fn/company-solution-admin-api/patch-phone-archive-status';
import { searchAnalyticsByCompany } from '../fn/company-solution-admin-api/search-analytics-by-company';
import { SearchAnalyticsByCompany$Params } from '../fn/company-solution-admin-api/search-analytics-by-company';
import { searchCompany } from '../fn/company-solution-admin-api/search-company';
import { SearchCompany$Params } from '../fn/company-solution-admin-api/search-company';
import { searchPhoneCompany } from '../fn/company-solution-admin-api/search-phone-company';
import { SearchPhoneCompany$Params } from '../fn/company-solution-admin-api/search-phone-company';
import { updateCompanyByRef } from '../fn/company-solution-admin-api/update-company-by-ref';
import { UpdateCompanyByRef$Params } from '../fn/company-solution-admin-api/update-company-by-ref';
import { updateCompanyEmailReport } from '../fn/company-solution-admin-api/update-company-email-report';
import { UpdateCompanyEmailReport$Params } from '../fn/company-solution-admin-api/update-company-email-report';
import { updateCompanyLogo1 } from '../fn/company-solution-admin-api/update-company-logo-1';
import { UpdateCompanyLogo1$Params } from '../fn/company-solution-admin-api/update-company-logo-1';
import { updateGlobalConsumptionPrices } from '../fn/company-solution-admin-api/update-global-consumption-prices';
import { UpdateGlobalConsumptionPrices$Params } from '../fn/company-solution-admin-api/update-global-consumption-prices';
import { updateTrialEndsAt } from '../fn/company-solution-admin-api/update-trial-ends-at';
import { UpdateTrialEndsAt$Params } from '../fn/company-solution-admin-api/update-trial-ends-at';
import { updateWalletConsumptionSettings } from '../fn/company-solution-admin-api/update-wallet-consumption-settings';
import { UpdateWalletConsumptionSettings$Params } from '../fn/company-solution-admin-api/update-wallet-consumption-settings';
import { WalletConsumptionConfiguration } from '../models/wallet-consumption-configuration';

@Injectable({ providedIn: 'root' })
export class CompanySolutionAdminApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateCompanyByRef()` */
  static readonly UpdateCompanyByRefPath = '/v1/api/admin-ui/company/update/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCompanyByRef()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateCompanyByRef$Response(params: UpdateCompanyByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseCompany>> {
    return updateCompanyByRef(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCompanyByRef$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateCompanyByRef(params: UpdateCompanyByRef$Params, context?: HttpContext): Observable<ApiResponseCompany> {
    return this.updateCompanyByRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseCompany>): ApiResponseCompany => r.body)
    );
  }

  /** Path part for operation `updateCompanyEmailReport()` */
  static readonly UpdateCompanyEmailReportPath = '/v1/api/admin-ui/company/update-email-report';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCompanyEmailReport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCompanyEmailReport$Response(params: UpdateCompanyEmailReport$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseCompanyEmailReportUpdateRequest>> {
    return updateCompanyEmailReport(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCompanyEmailReport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCompanyEmailReport(params: UpdateCompanyEmailReport$Params, context?: HttpContext): Observable<ApiResponseCompanyEmailReportUpdateRequest> {
    return this.updateCompanyEmailReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseCompanyEmailReportUpdateRequest>): ApiResponseCompanyEmailReportUpdateRequest => r.body)
    );
  }

  /** Path part for operation `getWalletConsumptionSettings()` */
  static readonly GetWalletConsumptionSettingsPath = '/v1/api/admin-ui/company/consumption-settings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWalletConsumptionSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWalletConsumptionSettings$Response(params?: GetWalletConsumptionSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<WalletConsumptionConfiguration>> {
    return getWalletConsumptionSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWalletConsumptionSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWalletConsumptionSettings(params?: GetWalletConsumptionSettings$Params, context?: HttpContext): Observable<WalletConsumptionConfiguration> {
    return this.getWalletConsumptionSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<WalletConsumptionConfiguration>): WalletConsumptionConfiguration => r.body)
    );
  }

  /** Path part for operation `updateWalletConsumptionSettings()` */
  static readonly UpdateWalletConsumptionSettingsPath = '/v1/api/admin-ui/company/consumption-settings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateWalletConsumptionSettings()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateWalletConsumptionSettings$Response(params: UpdateWalletConsumptionSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<WalletConsumptionConfiguration>> {
    return updateWalletConsumptionSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateWalletConsumptionSettings$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateWalletConsumptionSettings(params: UpdateWalletConsumptionSettings$Params, context?: HttpContext): Observable<WalletConsumptionConfiguration> {
    return this.updateWalletConsumptionSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<WalletConsumptionConfiguration>): WalletConsumptionConfiguration => r.body)
    );
  }

  /** Path part for operation `getGlobalConsumptionPrices()` */
  static readonly GetGlobalConsumptionPricesPath = '/v1/api/admin-ui/company/consumption-prices';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGlobalConsumptionPrices()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGlobalConsumptionPrices$Response(params: GetGlobalConsumptionPrices$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: string;
}>> {
    return getGlobalConsumptionPrices(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGlobalConsumptionPrices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGlobalConsumptionPrices(params: GetGlobalConsumptionPrices$Params, context?: HttpContext): Observable<{
[key: string]: string;
}> {
    return this.getGlobalConsumptionPrices$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
[key: string]: string;
}>): {
[key: string]: string;
} => r.body)
    );
  }

  /** Path part for operation `updateGlobalConsumptionPrices()` */
  static readonly UpdateGlobalConsumptionPricesPath = '/v1/api/admin-ui/company/consumption-prices';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateGlobalConsumptionPrices()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateGlobalConsumptionPrices$Response(params: UpdateGlobalConsumptionPrices$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: string;
}>> {
    return updateGlobalConsumptionPrices(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateGlobalConsumptionPrices$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateGlobalConsumptionPrices(params: UpdateGlobalConsumptionPrices$Params, context?: HttpContext): Observable<{
[key: string]: string;
}> {
    return this.updateGlobalConsumptionPrices$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
[key: string]: string;
}>): {
[key: string]: string;
} => r.body)
    );
  }

  /** Path part for operation `getCompanyLogo1()` */
  static readonly GetCompanyLogo1Path = '/v1/api/admin-ui/company/media/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyLogo1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyLogo1$Response(params: GetCompanyLogo1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
    return getCompanyLogo1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyLogo1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyLogo1(params: GetCompanyLogo1$Params, context?: HttpContext): Observable<{
}> {
    return this.getCompanyLogo1$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /** Path part for operation `updateCompanyLogo1()` */
  static readonly UpdateCompanyLogo1Path = '/v1/api/admin-ui/company/media/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCompanyLogo1()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateCompanyLogo1$Response(params: UpdateCompanyLogo1$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseCompany>> {
    return updateCompanyLogo1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCompanyLogo1$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateCompanyLogo1(params: UpdateCompanyLogo1$Params, context?: HttpContext): Observable<ApiResponseCompany> {
    return this.updateCompanyLogo1$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseCompany>): ApiResponseCompany => r.body)
    );
  }

  /** Path part for operation `createCompany()` */
  static readonly CreateCompanyPath = '/v1/api/admin-ui/company';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCompany()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createCompany$Response(params: CreateCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseCompany>> {
    return createCompany(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createCompany$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createCompany(params: CreateCompany$Params, context?: HttpContext): Observable<ApiResponseCompany> {
    return this.createCompany$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseCompany>): ApiResponseCompany => r.body)
    );
  }

  /** Path part for operation `convertToPermanentClient()` */
  static readonly ConvertToPermanentClientPath = '/v1/api/admin-ui/company/trial/{ref}/convert-to-client';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `convertToPermanentClient()` instead.
   *
   * This method doesn't expect any request body.
   */
  convertToPermanentClient$Response(params: ConvertToPermanentClient$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTrialStatus>> {
    return convertToPermanentClient(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `convertToPermanentClient$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  convertToPermanentClient(params: ConvertToPermanentClient$Params, context?: HttpContext): Observable<ApiResponseTrialStatus> {
    return this.convertToPermanentClient$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseTrialStatus>): ApiResponseTrialStatus => r.body)
    );
  }

  /** Path part for operation `searchCompany()` */
  static readonly SearchCompanyPath = '/v1/api/admin-ui/company/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchCompany()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchCompany$Response(params: SearchCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultCompany>> {
    return searchCompany(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchCompany$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchCompany(params: SearchCompany$Params, context?: HttpContext): Observable<ApiResponsePagedResultCompany> {
    return this.searchCompany$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultCompany>): ApiResponsePagedResultCompany => r.body)
    );
  }

  /** Path part for operation `searchPhoneCompany()` */
  static readonly SearchPhoneCompanyPath = '/v1/api/admin-ui/company/search-phone';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchPhoneCompany()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchPhoneCompany$Response(params: SearchPhoneCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultPhoneCompany>> {
    return searchPhoneCompany(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchPhoneCompany$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchPhoneCompany(params: SearchPhoneCompany$Params, context?: HttpContext): Observable<ApiResponsePagedResultPhoneCompany> {
    return this.searchPhoneCompany$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultPhoneCompany>): ApiResponsePagedResultPhoneCompany => r.body)
    );
  }

  /** Path part for operation `searchAnalyticsByCompany()` */
  static readonly SearchAnalyticsByCompanyPath = '/v1/api/admin-ui/company/analytics-chat/{companyId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchAnalyticsByCompany()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchAnalyticsByCompany$Response(params: SearchAnalyticsByCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAnalytics>> {
    return searchAnalyticsByCompany(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchAnalyticsByCompany$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchAnalyticsByCompany(params: SearchAnalyticsByCompany$Params, context?: HttpContext): Observable<ApiResponseAnalytics> {
    return this.searchAnalyticsByCompany$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseAnalytics>): ApiResponseAnalytics => r.body)
    );
  }

  /** Path part for operation `updateTrialEndsAt()` */
  static readonly UpdateTrialEndsAtPath = '/v1/api/admin-ui/company/trial/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTrialEndsAt()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateTrialEndsAt$Response(params: UpdateTrialEndsAt$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTrialStatus>> {
    return updateTrialEndsAt(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTrialEndsAt$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateTrialEndsAt(params: UpdateTrialEndsAt$Params, context?: HttpContext): Observable<ApiResponseTrialStatus> {
    return this.updateTrialEndsAt$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseTrialStatus>): ApiResponseTrialStatus => r.body)
    );
  }

  /** Path part for operation `patchPhoneArchiveStatus()` */
  static readonly PatchPhoneArchiveStatusPath = '/v1/api/admin-ui/company/phone/archive/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchPhoneArchiveStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchPhoneArchiveStatus$Response(params: PatchPhoneArchiveStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return patchPhoneArchiveStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchPhoneArchiveStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchPhoneArchiveStatus(params: PatchPhoneArchiveStatus$Params, context?: HttpContext): Observable<void> {
    return this.patchPhoneArchiveStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patchArchiveStatus4()` */
  static readonly PatchArchiveStatus4Path = '/v1/api/admin-ui/company/archive/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchArchiveStatus4()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchArchiveStatus4$Response(params: PatchArchiveStatus4$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return patchArchiveStatus4(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchArchiveStatus4$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchArchiveStatus4(params: PatchArchiveStatus4$Params, context?: HttpContext): Observable<void> {
    return this.patchArchiveStatus4$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patchApproveStatus()` */
  static readonly PatchApproveStatusPath = '/v1/api/admin-ui/company/approve/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchApproveStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchApproveStatus$Response(params: PatchApproveStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return patchApproveStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchApproveStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchApproveStatus(params: PatchApproveStatus$Params, context?: HttpContext): Observable<void> {
    return this.patchApproveStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getCompanyWhatsAppConfig()` */
  static readonly GetCompanyWhatsAppConfigPath = '/v1/api/admin-ui/company/{ref}/whatsapp-config';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyWhatsAppConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyWhatsAppConfig$Response(params: GetCompanyWhatsAppConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListWhatsAppConfig>> {
    return getCompanyWhatsAppConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyWhatsAppConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyWhatsAppConfig(params: GetCompanyWhatsAppConfig$Params, context?: HttpContext): Observable<ApiResponseListWhatsAppConfig> {
    return this.getCompanyWhatsAppConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListWhatsAppConfig>): ApiResponseListWhatsAppConfig => r.body)
    );
  }

  /** Path part for operation `getCompanyByRef()` */
  static readonly GetCompanyByRefPath = '/v1/api/admin-ui/company/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyByRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyByRef$Response(params: GetCompanyByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseCompany>> {
    return getCompanyByRef(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyByRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyByRef(params: GetCompanyByRef$Params, context?: HttpContext): Observable<ApiResponseCompany> {
    return this.getCompanyByRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseCompany>): ApiResponseCompany => r.body)
    );
  }

  /** Path part for operation `getSignupSurvey()` */
  static readonly GetSignupSurveyPath = '/v1/api/admin-ui/company/signup-survey/{companyId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSignupSurvey()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSignupSurvey$Response(params: GetSignupSurvey$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseSignupSurvey>> {
    return getSignupSurvey(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSignupSurvey$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSignupSurvey(params: GetSignupSurvey$Params, context?: HttpContext): Observable<ApiResponseSignupSurvey> {
    return this.getSignupSurvey$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseSignupSurvey>): ApiResponseSignupSurvey => r.body)
    );
  }

  /** Path part for operation `downloadReportPdf()` */
  static readonly DownloadReportPdfPath = '/v1/api/admin-ui/company/pdf/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadReportPdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadReportPdf$Response(params: DownloadReportPdf$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return downloadReportPdf(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadReportPdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadReportPdf(params: DownloadReportPdf$Params, context?: HttpContext): Observable<string> {
    return this.downloadReportPdf$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `downloadReportPricePdf()` */
  static readonly DownloadReportPricePdfPath = '/v1/api/admin-ui/company/pdf-price/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadReportPricePdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadReportPricePdf$Response(params: DownloadReportPricePdf$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return downloadReportPricePdf(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadReportPricePdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadReportPricePdf(params: DownloadReportPricePdf$Params, context?: HttpContext): Observable<string> {
    return this.downloadReportPricePdf$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `allCompaniesNumbersList()` */
  static readonly AllCompaniesNumbersListPath = '/v1/api/admin-ui/company/numbers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `allCompaniesNumbersList()` instead.
   *
   * This method doesn't expect any request body.
   */
  allCompaniesNumbersList$Response(params: AllCompaniesNumbersList$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListPhoneCompany>> {
    return allCompaniesNumbersList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `allCompaniesNumbersList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  allCompaniesNumbersList(params: AllCompaniesNumbersList$Params, context?: HttpContext): Observable<ApiResponseListPhoneCompany> {
    return this.allCompaniesNumbersList$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListPhoneCompany>): ApiResponseListPhoneCompany => r.body)
    );
  }

  /** Path part for operation `getListCompany()` */
  static readonly GetListCompanyPath = '/v1/api/admin-ui/company/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getListCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  getListCompany$Response(params: GetListCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListCompany>> {
    return getListCompany(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getListCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getListCompany(params: GetListCompany$Params, context?: HttpContext): Observable<ApiResponseListCompany> {
    return this.getListCompany$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListCompany>): ApiResponseListCompany => r.body)
    );
  }

  /** Path part for operation `getCompanyEmails()` */
  static readonly GetCompanyEmailsPath = '/v1/api/admin-ui/company/emails/{companyId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyEmails()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyEmails$Response(params: GetCompanyEmails$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseCompany>> {
    return getCompanyEmails(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyEmails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyEmails(params: GetCompanyEmails$Params, context?: HttpContext): Observable<ApiResponseCompany> {
    return this.getCompanyEmails$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseCompany>): ApiResponseCompany => r.body)
    );
  }

  /** Path part for operation `getConsumptionReports()` */
  static readonly GetConsumptionReportsPath = '/v1/api/admin-ui/company/consumption-reports';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsumptionReports()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsumptionReports$Response(params: GetConsumptionReports$Params, context?: HttpContext): Observable<StrictHttpResponse<PageConsumptionReportDto>> {
    return getConsumptionReports(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsumptionReports$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsumptionReports(params: GetConsumptionReports$Params, context?: HttpContext): Observable<PageConsumptionReportDto> {
    return this.getConsumptionReports$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageConsumptionReportDto>): PageConsumptionReportDto => r.body)
    );
  }

  /** Path part for operation `deleteCompnayByRef()` */
  static readonly DeleteCompnayByRefPath = '/v1/api/admin-ui/company/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCompnayByRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCompnayByRef$Response(params: DeleteCompnayByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteCompnayByRef(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteCompnayByRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCompnayByRef(params: DeleteCompnayByRef$Params, context?: HttpContext): Observable<void> {
    return this.deleteCompnayByRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deletePhoneCompanyByRef()` */
  static readonly DeletePhoneCompanyByRefPath = '/v1/api/admin-ui/company/phone/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePhoneCompanyByRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePhoneCompanyByRef$Response(params: DeletePhoneCompanyByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deletePhoneCompanyByRef(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deletePhoneCompanyByRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePhoneCompanyByRef(params: DeletePhoneCompanyByRef$Params, context?: HttpContext): Observable<void> {
    return this.deletePhoneCompanyByRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
